import client from "../config/axios";

export const storeAssetByCourseProfile = async (data) => {
    const config = {
      headers: { 'Content-Type': 'multipart/form-data' }
    };
    const response = await client.post('/asset/by-course-profile',data, config);
    return response.data;
  }
